import { useQuery } from '@tanstack/react-query';
import { http, returnIfNotFoundError } from 'services/http';
import { WAREHOUSE_TASK_ITEMS_GET_MANY } from 'api/query-keys.ts';
import type { TWarehouseTaskItemRes } from 'api/swagger';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';

export const useGetWarehouseTaskItems = (whTaskId: number) => {
  return useQuery<WithPagination<TWarehouseTaskItemRes[]>>({
    queryKey: [WAREHOUSE_TASK_ITEMS_GET_MANY, whTaskId],
    queryFn: async () => {
      try {
        const { data, headers } = await http.get<TWarehouseTaskItemRes[]>(
          `/v1/warehouse-tasks/${whTaskId}/warehouse-task-items`,
        );
        const pagination = preparePagination(headers);

        return { data, pagination };
      } catch (error) {
        return returnIfNotFoundError<WithPagination<[]>>(error, { data: [], pagination: null });
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
    cacheTime: 60 * 1000,
  });
};
